import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ArticleMenuItemsService {
  private _onArticleMenuItemsUpdate$ = new Subject<void>();

  public get onArticleMenuItemsUpdate$(): Observable<void> {
    return this._onArticleMenuItemsUpdate$.asObservable();
  }

  public articleMenuItemsRefreshed(): void {
    this._onArticleMenuItemsUpdate$.next(undefined);
  }
}
